import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Users,
  UserCheck,
  Clock,
  MailWarning,
  UserX,
  UserPlus,
  DollarSign,
  Mail,
} from "lucide-react";
import { useRealAdminMetrics } from "@/hooks/useRealAdminMetrics";

const RealMetricsCards = () => {
  const m = useRealAdminMetrics();

  if (m.loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-28" />
        ))}
      </div>
    );
  }

  const cards = [
    {
      label: "Total de Usuários",
      value: m.totalUsers,
      icon: Users,
      gradient: "from-blue-500/10 to-blue-600/5",
      iconColor: "text-blue-500",
      border: "border-blue-500/30",
    },
    {
      label: "Ativos Pagos",
      value: m.activeSubscribers,
      icon: UserCheck,
      gradient: "from-emerald-500/10 to-emerald-600/5",
      iconColor: "text-emerald-500",
      border: "border-emerald-500/30",
    },
    {
      label: "Vencidos",
      value: m.expiredUsers,
      icon: Clock,
      gradient: "from-red-500/10 to-red-600/5",
      iconColor: "text-red-500",
      border: "border-red-500/30",
    },
    {
      label: "Sem Confirmar",
      value: m.unconfirmedUsers,
      icon: MailWarning,
      gradient: "from-orange-500/10 to-orange-600/5",
      iconColor: "text-orange-500",
      border: "border-orange-500/30",
    },
    {
      label: "Plano Free",
      value: m.freeUsers,
      icon: UserX,
      gradient: "from-slate-500/10 to-slate-600/5",
      iconColor: "text-slate-500",
      border: "border-slate-500/30",
    },
    {
      label: "Novos (7 dias)",
      value: m.newUsers7d,
      icon: UserPlus,
      gradient: "from-purple-500/10 to-purple-600/5",
      iconColor: "text-purple-500",
      border: "border-purple-500/30",
      subtitle: `${m.newUsers24h} nas últimas 24h`,
    },
    {
      label: "Receita do Mês",
      value: `R$ ${m.monthlyRevenue.toFixed(2).replace(".", ",")}`,
      icon: DollarSign,
      gradient: "from-yellow-500/10 to-amber-600/5",
      iconColor: "text-yellow-500",
      border: "border-yellow-500/30",
    },
    {
      label: "Emails (30 dias)",
      value: m.totalEmails30d,
      icon: Mail,
      gradient: "from-cyan-500/10 to-cyan-600/5",
      iconColor: "text-cyan-500",
      border: "border-cyan-500/30",
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {cards.map((c) => {
        const Icon = c.icon;
        return (
          <Card
            key={c.label}
            className={`bg-gradient-to-br ${c.gradient} border ${c.border} hover:scale-[1.02] transition-transform`}
          >
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-2">
                <Icon className={`h-6 w-6 ${c.iconColor}`} />
              </div>
              <p className="text-2xl font-bold leading-tight">{c.value}</p>
              <p className="text-xs text-muted-foreground mt-1">{c.label}</p>
              {c.subtitle && (
                <p className="text-[10px] text-muted-foreground/70 mt-0.5">{c.subtitle}</p>
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default RealMetricsCards;
